import { render } from "./GlobalHeaderSearchBar.vue?vue&type=template&id=fb3c418e"
import script from "./GlobalHeaderSearchBar.vue?vue&type=script&lang=js"
export * from "./GlobalHeaderSearchBar.vue?vue&type=script&lang=js"

import "./GlobalHeaderSearchBar.vue?vue&type=style&index=0&id=fb3c418e&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__